import React from 'react';
import TutorialSlideshow from './TutorialSlideshow';

// Reusable tutorial modal. Pass defaultTabId to open a specific tutorial tab
// (1=Getting Started, 2=Story, 3=World, 4=Design, 5=Print, 6=Ship, 7=Character Consistency).
export default function TutorialModal({ isOpen, onClose, defaultTabId = null }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-5xl w-full max-h-[90vh] overflow-auto">
        <div className="flex justify-between items-center px-6 py-3 border-b border-gray-200 sticky top-0 bg-white">
          <h2 className="text-lg font-bold text-gray-900">Tutorial</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
            aria-label="Close tutorial"
          >
            ✕
          </button>
        </div>
        <div className="px-6 py-4">
          <TutorialSlideshow defaultTabId={defaultTabId} />
        </div>
      </div>
    </div>
  );
}
